/** Privacy policy link at the bottom of the Settings dialog — CrazyGames builds and the store app (App Store guideline 5.1.1). */

/**
 * @param {string | null | undefined} [buildVariant]
 * @returns {boolean}
 */
export function shouldShowPrivacyPolicyLink(buildVariant) {
  return buildVariant === "crazygames" || buildVariant === "app";
}

/**
 * @param {HTMLElement | null | undefined} el
 * @param {string | null | undefined} [buildVariant]
 */
export function applyPrivacyPolicyLinkVisibility(el, buildVariant) {
  if (!el) return;
  if (shouldShowPrivacyPolicyLink(buildVariant)) {
    el.classList.remove("hidden");
    el.removeAttribute("aria-hidden");
    return;
  }
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
}
